import { render, staticRenderFns } from "./HorarioAtencion.vue?vue&type=template&id=72341216&scoped=true"
import script from "./HorarioAtencion.vue?vue&type=script&lang=js"
export * from "./HorarioAtencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72341216",
  null
  
)

export default component.exports